import script from "./CollapsiblePropertyTitleDeeds.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyTitleDeeds.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyTitleDeeds.vue?vue&type=style&index=0&id=c809ba80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c809ba80"]])

export default __exports__